import React from 'react';

import { Container } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../../shared/providers';
import { PageTitle } from '../../../shared/components/ui-components';
import { getRouteParam } from '../../../shared/utils/angularUtils';
import { FoodType } from '../../constants/foodType';
import { pathQueryParams } from '../../constants/pathQueryParams';
import { getHumanizeFoodType } from '../../utils';
import { useFoodFormInitialValues } from './hooks/useFoodFormInitialValues';
import { FoodForm } from './FoodForm/FoodForm';

type NgzFoodFormProps = {
  foodType: FoodType;
  isEdit: boolean;
};

const NgzFoodForm = ({ foodType, isEdit }: NgzFoodFormProps) => {
  const id = getRouteParam('id');
  const foodId = id ? Number(id) : undefined;
  const templateId = getRouteParam(pathQueryParams.template);

  const initialData = useFoodFormInitialValues({ foodType, foodId, templateId, isEdit });

  const title = `${isEdit ? 'Edit' : 'Add'} ${getHumanizeFoodType(foodType)}`;

  return (
    <Container>
      <PageTitle title={title} />
      {initialData && (
        <FoodForm
          foodType={foodType}
          isEdit={isEdit}
          initialData={initialData}
          foodId={foodId}
          templateId={templateId}
        />
      )}
    </Container>
  );
};

angularizeWithProviders(NgzFoodForm, 'ngzFoodForm', { foodType: '@', isEdit: '<' });
